/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_Timecodes_WaitInputs */

const en_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating timecodes of events... please wait...`)
};

const fr_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul des codes temporels des événements... veuillez patienter...`)
};

const de_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes der Ereignisse werden berechnet... Bitte warten...`)
};

const it_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo dei codici temporali degli eventi... attendere prego...`)
};

const ru_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычисление временных кодов событий... пожалуйста, подождите...`)
};

const es_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando códigos de tiempo de eventos... por favor espere...`)
};

const zh_cn2_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在计算事件时间码……请稍候……`)
};

const ja_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのタイムコードを計算しています...お待ちください...`)
};

const hi_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं के टाइमकोड की गणना की जा रही है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_calculating_timecodes_wait = /** @type {(inputs: Calculating_Timecodes_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando os códigos de tempo dos eventos... aguarde...`)
};

/**
* | output |
* | --- |
* | "Calculating timecodes of events... please wait..." |
*
* @param {Calculating_Timecodes_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_timecodes_wait = /** @type {((inputs?: Calculating_Timecodes_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_Timecodes_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_calculating_timecodes_wait(inputs)
	if (locale === "de") return de_calculating_timecodes_wait(inputs)
	if (locale === "it") return it_calculating_timecodes_wait(inputs)
	if (locale === "ru") return ru_calculating_timecodes_wait(inputs)
	if (locale === "es") return es_calculating_timecodes_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_calculating_timecodes_wait(inputs)
	if (locale === "ja") return ja_calculating_timecodes_wait(inputs)
	if (locale === "hi") return hi_calculating_timecodes_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_calculating_timecodes_wait(inputs)
	return en_calculating_timecodes_wait(inputs)
});